"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0;
var questions = [{
  prompt: "",
  extraText: "What is your difficult situation and the unhelpful thoughts?",
  placeholder: "Write the situation and the associated thoughts here…",
  tips: "TIPS: Write as many unhelpful thoughts as you can think of.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What do these thoughts or my reaction to this situation mean about me as a person? (Question 1 of 3)",
  placeholder: "Write what it means about you here…",
  tips: "TIPS: Think about the way you think of yourself deep down when you act or think this way. ",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What do these thoughts or my reaction to this situation mean about me as a person? (Question 2 of 3)",
  placeholder: "Write what it means about you here…",
  tips: "TIPS: What does it mean about you that you are ashamed to admit?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What do these thoughts or my reaction to this situation mean about me as a person? (Question 3 of 3)",
  placeholder: "Write what it means about you here…",
  tips: "TIPS: What does it mean about you that you are afraid to admit?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the worst thing that could happen? (Question 1 of 3)",
  placeholder: "Write the next possible worrying outcome that could happen here...",
  tips: "TIPS: The previous three questions help identify a core belief. These next three questions help to identify a core fear. Follow the thinking pattern that is worried, anxious or fearful. What is that part of your thinking saying? What is it worried will happen?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the worst thing that could happen? (Question 2 of 3)",
  placeholder: "Write the next possible worrying outcome that could happen here...",
  tips: "TIPS: There might not be a next fearful thing if you’ve already identified the worst thing. However, there might be other worrying things that could happen if the worst thing happened. Write them here.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the worst thing that could happen? (Question 3 of 3) ",
  placeholder: "Write the next possible worrying outcome that could happen here...",
  tips: "TIPS: Sometimes we have several core fears. If you can identify another fear, write it here. If you can’t find another one, leave this blank.",
  type: "multirow",
  aggregated: true,
  optional: true
}, {
  prompt: "",
  extraText: "What are the core beliefs or core fears that you identified from doing this exercise?",
  placeholder: "Write your core beliefs or core fears here...",
  tips: "TIPS: You might only have one or several. Also, sometimes identifying a core belief can bring up some sadness. That’s normal so remember to be kind to yourself if you feel sad.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "How are these beliefs unhelpful?",
  placeholder: "Write the reasons why these beliefs are unhelpful here...",
  tips: "TIPS: How do you react when you believe them? How do you treat yourself? How do you treat others? How does it impact on your health, your relationships, your career, your stress levels?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "How are these beliefs inaccurate?",
  placeholder: "Write the reasons why these beliefs aren’t 100% true here...",
  tips: "TIPS: What would your best friend say if you told them about these beliefs? What would the healthy part of your thinking say about these beliefs? What evidence is there from your life that these beliefs aren’t true?",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the next thought you want to retrain?",
  placeholder: "Write down any unhelpful thoughts that still feel true here...",
  tips: "TIPS: Core beliefs and core fears usually take multiple times of doing these exercises to retrain. The important thing is to notice the thoughts that still feel true and to retrain these in order to shift the underlying beliefs.",
  type: "multirow",
  aggregated: true
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 9),
    rootThought: answers[9]
  };
}